import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState, CATEGORY_FEATURE_KEY } from '../../../app.state';
import { LAYOUT_FEATURE_KEY } from '@app/marketplace/storage/storage.state';
import { TreeviewItem } from 'ngx-treeview';
import * as fromStorage from '@app/marketplace/storage/storage.state';

export const layoutFeature = createFeatureSelector<fromStorage.AppStorageState>(LAYOUT_FEATURE_KEY);
export const selectCategoryTreeLoading = createSelector(
  layoutFeature,
  (state: fromStorage.AppStorageState) => state.categoryTree?.isLoading
);
export const selectCategoryTree = createSelector(
  layoutFeature,
  (state: fromStorage.AppStorageState) => state.categoryTree?.data
);
export const selectCategoryTreeView = createSelector(
  layoutFeature,
  (state: fromStorage.AppStorageState) => {
    let children = [];
    state.categoryTree.data?.data.filter(x => x.value == state.categoryTree.parentCategory).forEach(t => {
      t.children.map(c => {
          children.push(new TreeviewItem({
            text: c.text,
            value: c.value
          }))
      });
    });
    return children;
  }
);